module.exports = __webpack_public_path__ + "static/cover3-8941494713b4e1e0dcf1a8a7e8f4414a.png";